import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IPopcornRepository } from '../../repositories/interfaces/iPopcornRepository';

export interface IForgetPinUseCase {
    execute(apikey: string, username: string, identityToken: string, authToken: string): Promise<any>;
}

export class ForgetPinUseCase implements IForgetPinUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get forgetPin(): IPopcornRepository {
        return container.resolve<IPopcornRepository>(DI.REPOSITORIES.IPopcornRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(apikey: string, username: string, identityToken: string, authToken: string): Promise<any> {
        const response = await this.forgetPin.forgotPin(apikey, username, identityToken, authToken);
        return response.data;
    }
}
